/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespCategoryTiles_itemSearch$ref = any;
type SbRespMainContent_itemSearch$ref = any;
type SbRespNullSearchResults_itemSearch$ref = any;
type SbRespPriceTiles_itemSearch$ref = any;
type SbRespTradeOnApprovalPromoBanner_itemSearch$ref = any;
type SbSharedBillboardAd_itemSearch$ref = any;
type SbSharedFollowSearchProvider_itemSearch$ref = any;
type SbSharedForceSearchLink_itemSearch$ref = any;
type SbSharedPageBreadcrumbs_itemSearch$ref = any;
type SbSharedSearchSuggestions_itemSearch$ref = any;
type SbSharedTitle_itemSearch$ref = any;
type SbSharedTopTileController_itemSearch$ref = any;
type SharedRespMoreWaysToBrowse_internalBuyLinks$ref = any;
type SuspectedTradeUserLoader_itemSearch$ref = any;
export type SbRespComponents_itemSearch$ref = any;
export type SbRespComponents_itemSearch = {
    readonly totalResults: number | null;
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly originalSearchTerm: string | null;
    } | null;
    readonly canShowSearchVariantBurgundy: boolean | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly internalBuyLinks: ReadonlyArray<{
        readonly " $fragmentRefs": SharedRespMoreWaysToBrowse_internalBuyLinks$ref;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedForceSearchLink_itemSearch$ref & SbSharedSearchSuggestions_itemSearch$ref & SbRespNullSearchResults_itemSearch$ref & SbSharedPageBreadcrumbs_itemSearch$ref & SbSharedTitle_itemSearch$ref & SbSharedTopTileController_itemSearch$ref & SbRespCategoryTiles_itemSearch$ref & SbSharedFollowSearchProvider_itemSearch$ref & SbSharedBillboardAd_itemSearch$ref & SbRespPriceTiles_itemSearch$ref & SbRespTradeOnApprovalPromoBanner_itemSearch$ref & SbRespMainContent_itemSearch$ref & SuspectedTradeUserLoader_itemSearch$ref;
    readonly " $refType": SbRespComponents_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespComponents_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchCorrections",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchCorrectionsType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "originalSearchTerm",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canShowSearchVariantBurgundy",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "internalBuyLinks",
            "storageKey": null,
            "args": null,
            "concreteType": "InternalBuyLinkType",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedForceSearchLink_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedSearchSuggestions_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespNullSearchResults_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedPageBreadcrumbs_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedTitle_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedTopTileController_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespCategoryTiles_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedFollowSearchProvider_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedBillboardAd_itemSearch",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespPriceTiles_itemSearch",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespTradeOnApprovalPromoBanner_itemSearch",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespMainContent_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SuspectedTradeUserLoader_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '33bd021e0b81d88f0fd59fe56ebadf74';
export default node;
